import { Flex } from 'antd';
import closeIcon from 'Assets/icons/close.svg';
import goBackIcon from 'Assets/icons/left-arrow.svg';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { closeAllContextMenu } from 'Redux/modules/webChat/actions';
import { Segment } from 'semantic-ui-react';

const buttonStyle = {
  background: 'none',
  border: 'none',
  padding: 0,
  cursor: 'pointer',
};

const ContextMenuHeader = ({ title, goBack, customClass = '' }) => {
  const dispatch = useDispatch();

  const closeMenu = () => {
    dispatch(closeAllContextMenu());
  };
  return (
    <Segment className={`menu-header ${customClass}`}>
      <Flex justify="space-between" flex={1} align="center">
        <Flex>
          {goBack && (
            <button type="button" onClick={goBack} style={buttonStyle}>
              <img src={goBackIcon} alt="close" />
            </button>
          )}
          <span style={{ fontSize: 16, fontWeight: 600 }}>{title}</span>
        </Flex>
        {/* {closeContextMenu && ( */}
        <button type="button" onClick={closeMenu} style={buttonStyle}>
          <img src={closeIcon} alt="close" />
        </button>
        {/* )} */}
      </Flex>
    </Segment>
  );
};

ContextMenuHeader.propTypes = {
  goBack: PropTypes.func,
  title: PropTypes.string,
  customClass: PropTypes.string,
};

export default ContextMenuHeader;
